import logger from '@eneco/common/log';
import * as SparkyIllustrations from '@eneco/sparky/illustrations';
import { Placeholder } from '@eneco/sparky/illustrations';
import { Illustrations } from '@sitecore/types/manual/Illustrations';

type IllustrationComponent = typeof Placeholder;

export const getIllustration = (illustrationName: Illustrations) => {
  if (illustrationName in SparkyIllustrations) {
    return (SparkyIllustrations as Record<string, IllustrationComponent>)[illustrationName];
  }
  logger.error('wVRxzv', `Illustration ${illustrationName} could not be found. A placeholder will be rendered.`);
  return Placeholder;
};
